import { useEffect, useState } from 'react';
import { CheckboxEntityType, UseSelectionInterface } from './Filter.interface';

const useSelection = (initialChecked: CheckboxEntityType): UseSelectionInterface => {
  const [checkedEntity, setCheckedEntity] = useState<CheckboxEntityType>([]);

  const onChangeHandler = (key: string) => {
    setCheckedEntity([key]);
  };

  useEffect(() => {
    setCheckedEntity(initialChecked);
  }, [initialChecked]);

  return {
    checkedEntity,
    onChangeHandler,
  };
};

export default useSelection;
